module.exports = __webpack_public_path__ + "img/20.cefee6dc.png";